import { render, staticRenderFns } from "./StringFilterItem.vue?vue&type=template&id=587243e6&scoped=true&"
import script from "./StringFilterItem.vue?vue&type=script&lang=js&"
export * from "./StringFilterItem.vue?vue&type=script&lang=js&"
import style0 from "./StringFilterItem.vue?vue&type=style&index=0&id=587243e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587243e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VTabItem,VTextField})
